<script setup lang="ts">
useSeoMeta({
	title: "お問い合わせ｜株式会社Bang",
	description: "株式会社Bangへのお問い合わせについて掲載しています。",

	// OGP設定
	ogTitle: "お問い合わせ｜株式会社Bang",
	ogDescription: "株式会社Bangへのお問い合わせについて掲載しています。",
	ogUrl: "https://www.bang-inc.jp/contact",
});
const navItems = [
	{ text: "トップページ", href: "/" },
	{ text: "お問い合わせ" },
];
</script>
<template>
    <main class="contact">
        <!-- パンくずリスト -->
        <Breadcrumbs :items="navItems" />
        <div class="contact-body">
            <HeadingCorp :level="1">お問い合わせ</HeadingCorp>
            <p class="contact-text">
                お問合せの前にこちらも参考にご確認ください。<br class="button-pc">
                お客様より多く寄せられている問い合わせ内容を掲載しています。
            </p>
            <ButtonPrimary class="contact-button button-sp" size="sm" buttonType="faq">よくあるご質問</ButtonPrimary>
            <ButtonPrimary class="contact-button button-pc" size="md" buttonType="faq">よくあるご質問</ButtonPrimary>
            <p class="contact-description">掲載内容で解決できない方は、下記メールアドレスへお問い合わせください。</p>

            <!-- メールアドレス -->
            <div class="contact-email">
                <a href="mailto:info@bang-inc.jp" class="email-link">
                    <Icons name="envelope" />
                    info@bang-inc.jp
                </a>
            </div>

            <!-- 営業時間 -->
            <div class="business-hours">
                <h4 class="business-hours-title">営業時間</h4>
                <p class="business-hours-time">午前10時00分～午後6時00分</p>
                <p class="business-hours-note">（土曜・日曜・祝日・年末年始除く）</p>
            </div>
        </div>
    </main>
</template>

<style scoped lang="scss">
.button-sp {
    display: block;
    margin: auto;
}

.button-pc {
    display: none;
    margin: auto;
}

.contact {
    position: relative;
    width: min(91vw, 64.5rem);
    margin: auto;

    &::before {
        content: '';
        position: absolute;
        width: 20rem; // 320px
        height: 20rem; // 320px
        aspect-ratio: 1/1;
        left: -4rem; // -64px
        top: -3rem; // -48px
        border-radius: 20rem; // 320px
        box-sizing: border-box;
        border: 1.5rem solid #EFF7FF; // 24px
        z-index: -1; // コンテンツの背景に配置
        pointer-events: none; // クリックイベントを通す
    }

    &-body {
        padding: 2rem 0 4.5rem 0;
    }

    &-text,
    &-description {
        color: #252522;
        font-size: 1rem;
        font-weight: 400;
        line-height: 150%;
        margin-bottom: 1rem;
    }

    &-button,
    &-email {
        margin-bottom: 2.5rem;
    }
}

.contact-email {
    padding: 1rem;
    background: #EFF7FF;
    width: min(83vw, 35rem);

    .email-link {
        color: #2174C0;
        font-size: 1.125rem;
        font-weight: 400;
        line-height: 150%;
    }
}

.business-hours {
    color: #252522;
    font-size: 1rem;
    line-height: 150%;

    &-title {
        font-weight: 700;
    }

    &-time,
    &-note {
        font-weight: 400;
    }
}

// PC用のスタイル
@include mixin.media(pc) {

    .button-sp {
        display: none;
    }

    .button-pc {
        display: block;
    }

    .contact {
        &::before {
            width: 32.5rem; // 520px
            height: 32.5rem; // 520px
            left: -10.7rem; // -171.2px
            top: -4rem; // -64px
            border-radius: 32.5rem; // 520px
            border: 2.5rem solid #EFF7FF; // 24px
        }

        &-button,
        &-email {
            margin: unset;
            margin-bottom: 3rem;
        }
    }
}
</style>